import { render, staticRenderFns } from "./VideoStatement.vue?vue&type=template&id=68eb94f6"
import script from "./VideoStatement.vue?vue&type=script&lang=js"
export * from "./VideoStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports